import {useOwnership} from '@cohort/wallet/hooks/api/Ownerships';
import useNotify from '@cohort/wallet/hooks/notify';
import useScreenSizeContext from '@cohort/wallet/hooks/useScreenSize';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import {getMerchantSpaceRoute} from '@cohort/wallet/lib/Pages';
import DigitalAssetDetailPageDesktop from '@cohort/wallet/pages/space/DigitalAssetDetailPageDesktop';
import DigitalAssetDetailPageMobile from '@cohort/wallet/pages/space/DigitalAssetDetailPageMobile';
import React, {Fragment, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';

const DigitalAssetDetailPage: React.FC = () => {
  const {space} = useSpaceContext();
  const {isMobile} = useScreenSizeContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.digitalAssetDetailPage'});
  const navigate = useNavigate();
  const {ownershipId} = useParams();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {data: ownership} = useOwnership(ownershipId!, ownershipId !== undefined);
  const notify = useNotify();

  useEffect(() => {
    if (ownership?.status === 'transferred') {
      notify('error', t('nftAlreadySent'), {autoClose: false});
      navigate(getMerchantSpaceRoute(), {replace: true});
    }
  }, [navigate, ownership, space, t, notify]);

  const Page = isMobile ? DigitalAssetDetailPageMobile : DigitalAssetDetailPageDesktop;

  if (space === undefined || ownership === undefined) {
    return <Fragment />;
  }

  return <Page ownership={ownership} />;
};

export default DigitalAssetDetailPage;
